export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";

export const AUTH_USER = "AUTH_USER";
export const AUTH_USER_SUCCESS = "AUTH_USER_SUCCESS";
export const AUTH_USER_FAIL = "AUTH_USER_FAIL";

export const TOKEN_EXPIRED = "TOKEN_EXPIRED";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAIL = "LOGOUT_USER_FAIL";

export const API_ADMIN_GET_ALL_USER = "API_ADMIN_GET_ALL_USER";
export const API_ADMIN_GET_ALL_USER_SUCCESS = "API_ADMIN_GET_ALL_USER_SUCCESS";
export const API_ADMIN_GET_ALL_USER_FAIL = "API_ADMIN_GET_ALL_USER_FAIL";

export const API_ADMIN_GET_USER = "API_ADMIN_GET_USER";
export const API_ADMIN_GET_USER_SUCCESS = "API_ADMIN_GET_USER_SUCCESS";
export const API_ADMIN_GET_USER_FAIL = "API_ADMIN_GET_USER_FAIL";

export const API_ADMIN_POST_USER = "API_ADMIN_POST_USER";
export const API_ADMIN_POST_USER_SUCCESS = "API_ADMIN_POST_USER_SUCCESS";
export const API_ADMIN_POST_USER_FAIL = "API_ADMIN_POST_USER_FAIL";

export const API_ADMIN_PATCH_USER = "API_ADMIN_PATCH_USER";
export const API_ADMIN_PATCH_USER_SUCCESS = "API_ADMIN_PATCH_USER_SUCCESS";
export const API_ADMIN_PATCH_USER_FAIL = "API_ADMIN_PATCH_USER_FAIL";

export const API_ADMIN_DELETE_USER = "API_ADMIN_DELETE_USER";
export const API_ADMIN_DELETE_USER_SUCCESS = "API_ADMIN_DELETE_USER_SUCCESS";
export const API_ADMIN_DELETE_USER_FAIL = "API_ADMIN_DELETE_USER_FAIL";

export const API_RESET_PASSWORD = "API_RESET_PASSWORD";
export const API_RESET_PASSWORD_SUCCESS = "API_RESET_PASSWORD_SUCCESS";
export const API_RESET_PASSWORD_FAIL = "API_RESET_PASSWORD_FAIL";

export const API_FORGOT_PASSWORD = "API_FORGOT_PASSWORD";
export const API_FORGOT_PASSWORD_SUCCESS = "API_FORGOT_PASSWORD_SUCCESS";
export const API_FORGOT_PASSWORD_FAIL = "API_FORGOT_PASSWORD_FAIL";

export const ADMIN_RESET_FOCUS_USER = "ADMIN_RESET_FOCUS_USER";
export const ADMIN_INIT_NEW_USER = "ADMIN_INIT_NEW_USER";
export const SET_NURSE_MODE_USER = "SET_NURSE_MODE_USER";
export const SET_SESSION_CENTER_USER = "SET_SESSION_CENTER_USER";

export const API_GET_CONNECTED = "API_GET_CONNECTED";
export const API_GET_CONNECTED_SUCCESS = "API_GET_CONNECTED_SUCCESS";
export const API_GET_CONNECTED_FAIL = "API_GET_CONNECTED_FAIL";

export const API_GET_CONNECTED_SECRETARIES = "API_GET_CONNECTED_SECRETARIES";
export const API_GET_CONNECTED_SECRETARIES_SUCCESS = "API_GET_CONNECTED_SECRETARIES_SUCCESS";
export const API_GET_CONNECTED_SECRETARIES_FAIL = "API_GET_CONNECTED_SECRETARIES_FAIL";

export const API_PATCH_TOGGLE_NURSE_HELP = "API_PATCH_TOGGLE_NURSE_HELP";
export const API_PATCH_TOGGLE_NURSE_HELP_SUCCESS = "API_PATCH_TOGGLE_NURSE_HELP_SUCCESS";
export const API_PATCH_TOGGLE_NURSE_HELP_FAIL = "API_PATCH_TOGGLE_NURSE_HELP_FAIL";

export const API_GET_NURSE_HELP = "API_GET_NURSE_HELP";
export const API_GET_NURSE_HELP_SUCCESS = "API_GET_NURSE_HELP_SUCCESS";

export const API_GET_NEED_HELP = "API_GET_NEED_HELP";
export const API_GET_NEED_HELP_SUCCESS = "API_GET_NEED_HELP_SUCCESS";

export const API_PATCH_TOGGLE_NEED_HELP = "API_PATCH_TOGGLE_NEED_HELP";
export const API_PATCH_TOGGLE_NEED_HELP_SUCCESS = "API_PATCH_TOGGLE_NEED_HELP_SUCCESS";
export const API_PATCH_TOGGLE_NEED_HELP_FAIL = "API_PATCH_TOGGLE_NEED_HELP_FAIL";

export const GO_TO_RESULTS = "GO_TO_RESULTS";
export const GO_TO_RESULTS_SUCCESS = "GO_TO_RESULTS_SUCCESS";
export const GONE_TO_RESULTS = "GONE_TO_RESULTS";

export const TOGGLE_HELPFOLDERS_MY_CENTER = "TOGGLE_HELPFOLDERS_MY_CENTER";

export const API_ADMIN_GET_SAMPLERS_USER = "API_ADMIN_GET_SAMPLERS_USER";
export const API_ADMIN_GET_SAMPLERS_USER_SUCCESS = "API_ADMIN_GET_SAMPLERS_USER_SUCCESS";
export const API_ADMIN_GET_SAMPLERS_USER_FAIL = "API_ADMIN_GET_SAMPLERS_USER_FAIL";

export const API_PATCH_SOUND_NOTIFICATION = "API_PATCH_SOUND_NOTIFICATION";
export const API_PATCH_SOUND_NOTIFICATION_SUCCESS = "API_PATCH_SOUND_NOTIFICATION_SUCCESS";
export const API_PATCH_SOUND_NOTIFICATION_FAIL = "API_PATCH_SOUND_NOTIFICATION_FAIL";

export const API_PATCH_TEL_FOR_TVSEC = "API_PATCH_TEL_FOR_TVSEC";
export const API_PATCH_TEL_FOR_TVSEC_SUCCESS = "API_PATCH_TEL_FOR_TVSEC_SUCCESS";
export const API_PATCH_TEL_FOR_TVSEC_FAIL = "API_PATCH_TEL_FOR_TVSEC_FAIL";
